module.exports = __webpack_public_path__ + "img/单位换算.fedebfd6.png";